import axios from "axios";

const apiVersion = process.env.REACT_APP_API_VERSION || "";
const baseURL = process.env.REACT_APP_BE;
let url;
if(apiVersion !== ""){
  url = baseURL+"/"+apiVersion;
} else {
  url = baseURL;
}

const apiClient = axios.create({
  baseURL: url,
});

let activeRequests = 0;
let setGlobalLoading = () => {};
export const injectLoadingSetter = (setter) => {
  setGlobalLoading = setter;
};
// Attach token to every request
apiClient.interceptors.request.use(
  config => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    activeRequests++;
    setGlobalLoading(true);
    return config;
  },
  error => Promise.reject(error)
);

// Response Interceptor - hide loading + handle token
apiClient.interceptors.response.use(
  (response) => {
    activeRequests--;
    if (activeRequests <= 0 && setGlobalLoading) setGlobalLoading(false);
    return response;
  },
  (error) => {
    activeRequests--;
    if (activeRequests <= 0 && setGlobalLoading) setGlobalLoading(false);

    if (error.response?.status === 401) {
      localStorage.removeItem("token");

      const currentPath = window.location.pathname;
      const isSharablePage = /^\/recipe-share\/[^/]+$/.test(currentPath);

      if (!isSharablePage) {
        window.location.href = "/login"; // force logout on auth error
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
